import React from 'react';
import { Box, Container, Heading, Text, VStack, SimpleGrid, Image, HStack } from '@chakra-ui/react';
import { Star } from 'lucide-react';
interface Testimonial {
  name: string;
  location: string;
  image: string;
  text: string;
}
const testimonials: Testimonial[] = [{
  name: 'Carmen Rodríguez',
  location: 'Miami, FL',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop',
  text: 'Después de 3 meses sin hablar, él volvió. No fue casualidad. El trabajo fue real y los resultados también. Gracias por devolverme mi paz.'
}, {
  name: 'María Elena Torres',
  location: 'Los Angeles, CA',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop',
  text: 'Sentía que todo se me cerraba. Desde que empecé el proceso, las oportunidades llegaron solas. Mi negocio creció y mi vida cambió completamente.'
}, {
  name: 'Isabel Morales',
  location: 'Houston, TX',
  image: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400&h=400&fit=crop',
  text: 'Ella interfería en todo. Ahora ya no está. El corte fue efectivo y mi relación volvió a ser como antes. Fue lo mejor que pude hacer.'
}];
export function TestimonialsSection() {
  return <Box position="relative" py={{
    base: 12,
    md: 20
  }} overflow="hidden" bg="rgba(26, 26, 26, 0.5)" data-id="element-36">
      <Container maxW="container.xl" data-id="element-37">
        <VStack spacing={12} data-id="element-38">
          <VStack spacing={4} textAlign="center" data-id="element-39">
            <Heading as="h2" fontSize={{
            base: '2xl',
            md: '4xl'
          }} color="brand.400" textTransform="uppercase" fontWeight="black" letterSpacing="wide" textShadow="0 0 20px rgba(220, 38, 38, 0.8), 0 0 40px rgba(220, 38, 38, 0.4)" data-id="element-40">
              ELLAS ACTUARON A TIEMPO
            </Heading>
            <Text fontSize={{
            base: 'md',
            md: 'lg'
          }} color="gray.400" maxW="600px" data-id="element-41">
              Historias reales de personas que decidieron no seguir perdiendo
            </Text>
          </VStack>

          <SimpleGrid columns={{
          base: 1,
          md: 3
        }} spacing={8} w="full" data-id="element-42">
            {testimonials.map((testimonial, index) => <Box key={index} bg="rgba(0, 0, 0, 0.6)" borderWidth="2px" borderColor="gray.800" borderRadius="lg" overflow="hidden" backdropFilter="blur(10px)" transition="all 0.3s ease" _hover={{
            borderColor: 'brand.500',
            transform: 'translateY(-4px)',
            boxShadow: '0 10px 40px rgba(220, 38, 38, 0.3)'
          }} data-id="element-43">
                <VStack spacing={4} p={6} align="stretch" data-id="element-44">
                  <HStack spacing={4} data-id="element-45">
                    <Image src={testimonial.image} alt={testimonial.name} boxSize="60px" borderRadius="full" objectFit="cover" borderWidth="2px" borderColor="brand.500" data-id="element-46" />
                    <VStack align="start" spacing={0} flex={1} data-id="element-47">
                      <Text fontSize="md" color="white" fontWeight="bold" data-id="element-48">
                        {testimonial.name}
                      </Text>
                      <Text fontSize="sm" color="gray.400" data-id="element-49">
                        {testimonial.location}
                      </Text>
                    </VStack>
                  </HStack>

                  <HStack spacing={1} data-id="element-50">
                    {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#fbbf24" color="#fbbf24" data-id="element-51" />)}
                  </HStack>

                  <Text fontSize="sm" color="gray.300" lineHeight="tall" fontStyle="italic" data-id="element-52">
                    "{testimonial.text}"
                  </Text>
                </VStack>
              </Box>)}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>;
}